/** Small blueprint marks. No text, no figures. */

type MarkProps = { className?: string }

export function AdviseMark({ className }: MarkProps) {
  return (
    <svg className={className} viewBox="0 0 72 72" fill="none" aria-hidden="true">
      <rect x="8" y="14" width="40" height="28" stroke="currentColor" strokeWidth="1.5" />
      <path d="M16 42 L16 54 L30 42" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <line x1="16" y1="26" x2="38" y2="26" stroke="currentColor" strokeWidth="1" />
      <line x1="16" y1="33" x2="30" y2="33" stroke="currentColor" strokeWidth="1" />
    </svg>
  )
}

export function BuildMark({ className }: MarkProps) {
  return (
    <svg className={className} viewBox="0 0 72 72" fill="none" aria-hidden="true">
      <rect x="10" y="12" width="52" height="14" stroke="currentColor" strokeWidth="1.5" />
      <rect x="10" y="30" width="52" height="14" stroke="currentColor" strokeWidth="1.5" />
      <rect x="10" y="48" width="52" height="12" stroke="var(--accent)" strokeWidth="1.5" />
      <line x1="16" y1="54" x2="56" y2="54" stroke="var(--accent)" strokeWidth="1" />
    </svg>
  )
}

export function HireMark({ className }: MarkProps) {
  return (
    <svg className={className} viewBox="0 0 72 72" fill="none" aria-hidden="true">
      <circle cx="20" cy="24" r="7" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="52" cy="24" r="7" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="36" cy="50" r="7" stroke="var(--accent)" strokeWidth="1.5" />
      <line x1="27" y1="26" x2="45" y2="26" stroke="currentColor" strokeWidth="1.5" />
      <line x1="23" y1="30" x2="32" y2="45" stroke="currentColor" strokeWidth="1.5" />
      <line x1="49" y1="30" x2="40" y2="45" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}
